// @flow

/**
 * @author Junaid Atari <mj.atari@gmail.com>
 * @link http://junaidatari.com Author Website
 * @since 2020-08-29
 */

export const SET_ENVIRONMENT: string = 'SET_ENVIRONMENT';
